import i18n from '@dms/i18n';

export type ChoiceBooleanValue = 'true' | 'false' | 'null';

export const DEFAULT_VALUE_OPTIONS: {label: string; value: ChoiceBooleanValue}[] = [
  {label: i18n.t('general.labels.yes'), value: 'true'},
  {label: i18n.t('general.labels.no'), value: 'false'},
  {label: i18n.t('general.labels.empty'), value: 'null'},
];
